export { default as PaymentsTab } from "./paymentsTab";
